export default "__VITE_ASSET__Cf2kH1wR__"